enum ReservationFormSteps {
  TRIP_DETAILS = 0,
  MEMBER = 1,
  SUMMARY = 2,
}

export { ReservationFormSteps };
